import { Tables } from "database.types";

export const createTcgPlayeraAffiliateLink = (tcgplayerId: string) => {
  const url = new URL("https://partner.tcgplayer.com/c/6496111/1780961/21018");

  const tcgPlayerLink = `https://www.tcgplayer.com/product/${tcgplayerId}`;

  url.searchParams.set("u", tcgPlayerLink);

  return url.toString();
};
